import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '@astro/auth'
import { ConsultationInviteWatcher, SocketProvider } from '@astro/socket'
import './styles/shop.css'
import { ToastProvider } from './context/ToastContext.jsx'
import App from './App.jsx'

const queryClient = new QueryClient()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SocketProvider>
          <ToastProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
            {/* Video-consultation invite can arrive while shopping — hands off to jyotish. */}
            <ConsultationInviteWatcher />
          </ToastProvider>
        </SocketProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
